import React from 'react';
import { observer } from 'mobx-react';
import { setToken, setValidate } from '../config';

// Helpers
import { deleteCookie, getCookie, isAuthenticated } from '../helpers/helpers.js'

// Dependencies
import { FeatureFlag, LaunchDarkly } from 'react-launch-darkly';
import LogRocket from 'logrocket';

// Components
import Header from './Common/Header';
import Tools from './Common/Tools';
import DelayRender from './Common/DelayRender';
import Footer from './Common/Footer';
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';
import Confirm from './Common/Confirm';
import Prompt from './Common/Prompt';
import ExpireWarning from './Common/ExpireWarning';
import FeatureNotice from './Common/FeatureNotice';
import Toaster from './Common/Toaster';
import Notification from './Common/Notification';
import { config } from '../config';

// Store
import store from '../stores/';


const App = observer(class App extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.updateToken = this.updateToken.bind(this);
    this.getData = this.getData.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentWillMount() {
    const params = new URLSearchParams(location.search)
    const { SessionStore, HelpStore } = store;

    // If there’s a token provided in the URL, add it to session storage

    if(SessionStore.hasSessionStorage) {

      if(sessionStorage.getItem('token') && params.get('token')) {
        sessionStorage.removeItem('token');
        sessionStorage.setItem('token', params.get('token'))
        this.checkToken();
      }

      if(!sessionStorage.getItem('token') && params.get('token')) {
        sessionStorage.setItem('token', params.get('token'));

        // Check the token
        this.checkToken();

        // Set token to api header
        setToken(sessionStorage.getItem('token'));
        SessionStore.startTokenTimer(sessionStorage.getitem('token'))
      }
    } else {
      if(getCookie('token') && this.props.routing.location.query.token) {
        deleteCookie('token');
      }

      if(!getCookie('token') && this.props.routing.location.query.token) {
        document.cookie = `token=${this.props.routing.location.query.token}`;

        // Check the token
        this.checkToken();

        // Set token to api header
        setToken(getCookie('token'));
        SessionStore.startTokenTimer(getCookie('token'))

      }
    }

    // Retrieve user data from localStorage
    let userData = {}

    if(SessionStore.hasSessionStorage) {
      userData = sessionStorage.getItem('userData');
    } else {
      userData = getCookie('userData');
    }

    if(userData && !SessionStore.userData) {
      store.SessionStore.getLocalStorage(JSON.parse(userData));
    }

    // Get help documents
    if(!HelpStore.helpLoaded) {
      HelpStore.getHelp();
    }

    // Redirect if not logged in
    const _this = this;

    setTimeout(function(){
      if(!isAuthenticated()) {
        _this.props.routing.history.push('/account/sign-in');
      }
    });
  }

  componentDidMount() {
    const _this = this;
    const { SessionStore } = store;

    const tokenDelay = setInterval(function(){
      if(SessionStore.hasSessionStorage) {
        if(sessionStorage.getItem('token') ) {
          if(sessionStorage.getItem('token') === null) {return}
          _this.updateToken(sessionStorage.getItem('token'));
          clearInterval(tokenDelay);
          SessionStore.tokenSet = true;
          SessionStore.token = sessionStorage.getItem('token');
        }
      } else {
        if(getCookie('token')) {
          _this.updateToken(getCookie('token'));
          clearInterval(tokenDelay);
          SessionStore.tokenSet = true;
          SessionStore.token = getCookie('token');
        }
      }
    }, 100);

    let passwordReset = false;

    if(SessionStore.hasSessionStorage && sessionStorage.getItem('passwordReset')) {
      passwordReset = sessionStorage.getItem('passwordReset');
    } else if(getCookie('passwordReset')) {
      passwordReset = getCookie('passwordReset');
    }

    const userDataDelay = setInterval(function(){
      if(SessionStore.userData) {
        if(SessionStore.userData.forcePasswordReset && passwordReset !== 'true') {
          _this.props.routing.history.push('/update-password');
        }

        // Redirect if there’s a route specified in the token
        if(SessionStore.userData.route && !SessionStore.refresh) {
          _this.props.routing.history.push(SessionStore.userData.route);
        } else {
          SessionStore.refresh = false;
        }

        // If there’s a custom stylesheet specified, load it
        if(SessionStore.userData.cssUrl) {
          const cssId = 'account-css';

          if(!document.querySelector(`#${cssId}`)) {
            const customCss = document.createElement('link');
            customCss.type = 'text/css';
            customCss.rel  = 'stylesheet';
            customCss.id = cssId;
            customCss.href = SessionStore.userData.cssUrl;
            document.head.appendChild(customCss);
          }
        }

        clearInterval(userDataDelay);
      }
    }, 100);

    document.querySelector('body').className = document.querySelector('body').className.replace('logged-out', '');

    if(SessionStore.userData) {
      if(process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'production-b') {
        if(!store.SessionStore.logRocketInit) {
          LogRocket.init(config.logRocket);
          store.SessionStore.logRocketInit = true;
        }
      }
    }

    // Check browser support
    store.SessionStore.checkBrowser();
  }

  componentWillUpdate(nextProps) {
    // Set the feature in the HelpStore
    store.HelpStore.feature = nextProps.feature;
  }

  // componentWillUpdate() {
  //   let storedToken = sessionStorage.getItem('token');
  //
  //   // If the token has changed, update it
  //   if(this.state.token !== storedToken) {
  //     this.setState({
  //       token: storedToken
  //     });
  //     this.updateToken(storedToken);
  //   }
  // }

  checkToken() {
    const { SessionStore } = store;
    SessionStore.checkToken();
  }

  updateToken(token) {
    const { SessionStore } = store;

    setToken(token, this.getData);
    SessionStore.startTokenTimer(token)

    setValidate();
  }

  getData() {
    const { SessionStore } = store;
    const { history } = this.props;

    const profileDelay = setInterval(function(){
      if(SessionStore.hasSessionStorage) {
        if(sessionStorage.getItem('userData')) {
          const parsedUserData = JSON.parse(sessionStorage.getItem('userData'));
          SessionStore.getProctorAccount(parsedUserData.proctorAccountSid);
          SessionStore.getProfile(history);
          clearInterval(profileDelay);
        }
      } else {
        if(getCookie('userData')) {
          const parsedUserData = JSON.parse(getCookie('userData'));
          SessionStore.getProctorAccount(parsedUserData.proctorAccountSid);
          SessionStore.getProfile(history);
          clearInterval(profileDelay);
        }
      }
    }, 100);
  }

  checkAgreements(env) {
    const agreementDelay = setInterval(function(){
      const { userData } = store.SessionStore;

      if(userData && userData.sid) {
        clearInterval(agreementDelay);

        let agrOpts = {
          mode: 'popup',
          location: 'general-user-agreements',
          target: userData.sid,
          account: userData.proctorAccountSid
        }

        if(env === 'production') {
          agrOpts.application = 'AP6800b9e2e1794dbbbf6ad866194821d3';
          window.Agreements.setup(agrOpts);
        } else {
          agrOpts.application = 'APfb4f76ee1dc24d058048fdaed04f56f1';
          window.Agreements.setup(agrOpts);
        }
      }
    }, 100);
  }

  refresh() {
    const { history } = this.props;
    const { SessionStore } = store;
    const thisLocation = this.props.routing.history.location;

    history.replace('/refresh');

    setTimeout(function(){
      SessionStore.refresh = true;
      history.replace({ pathname: thisLocation.pathname, query: thisLocation.query });
    });
  }

  embedSupportChat() {
    const { userData } = store.SessionStore;
    const token = sessionStorage.getItem('token');
    const optionsDefined = !!window.inAppHelpOptions;

    if (!optionsDefined) {
      window.inAppHelpOptions = {
        token: token,
        application_sid: 'AP6800b9e2e1794dbbbf6ad866194821d3',
        context: 'proctor_account',
        sids: {
          proctor_account_sid: userData.proctorAccountSid,
          proctor_user_sid: userData.sid
        }
      };

      const script = document.createElement('script');
      script.src = config.supportScriptUrl;
      script.type = 'text/javascript';
      script.onload = () => window.initHelpCenter();

      document.body.appendChild(script);
    }
  }

  render() {
    const { SessionStore } = store;
    let test = null;

    // Environment (used by LaunchDarkly)
    let environment = 'develop';

    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      environment = 'production'
    }

    if(process.env.REACT_APP_ENVIRONMENT === 'stage') {
      environment = 'stage'
    }

    if(SessionStore.ldReady) {
      if(SessionStore.hasSessionStorage) {
        test = sessionStorage.getItem('token') && sessionStorage.getItem('userData');
      } else {
        test = getCookie('token') && getCookie('userData');
      }
    }

    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.className += ' touch';
    }

    // Remove no nav class from body
    document.querySelector('body').className = document.querySelector('body').className.replace('no-nav', '');

    if(SessionStore.tokenSet) {
      // LaunchDarkly user config
      let ldConfig = {}

      if(SessionStore.userData) {
        ldConfig = {
          key: SessionStore.userData.proctorAccountSid,
          custom: {
            domain: window.location.hostname,
            environment: environment,
            account: SessionStore.userData.proctorAccountSid,
            user: SessionStore.userData.sid
          }
        }
      }

      // Agreements UI
      const agrScript = document.querySelector('#agr-ui');

      if(!agrScript) {
        let agr = document.createElement('script');
        agr.id = 'agr-ui';
        agr.type = 'text/javascript';
        agr.async = true;

        if(process.env.REACT_APP_ENVIRONMENT === 'production') {
          agr.src = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
        } else {
          agr.src = 'https://s3.amazonaws.com/smarterservices-static-staging/agreements-ui/js/agreements.min.js';
        }

        const _this = this;

        agr.onload = function(){
          _this.checkAgreements(process.env.REACT_APP_ENVIRONMENT);
        };

        document.body.appendChild(agr);
      }

      // SessionStore.userData.skin = 'embed';
      // SessionStore.userData.route = '/reports';

      if(SessionStore.userData && SessionStore.userData.skin === 'embed') {
        if(document.body.className.indexOf('no-head') < 0) {
          document.body.className += ' no-head';
        }
      }
      return (
        <LaunchDarkly clientId={config.ldApiKey} user={ldConfig}>

          <FeatureFlag
            flagKey="maintenance-message"
            renderFeatureCallback={function(flagValue) {
              if(flagValue && typeof flagValue === 'object' && flagValue.message !== undefined){
                // Redirect to maintenance page
                window.location.href = `/maintenance`;
              }
            }}
          />

          <div className="viewport fill">
            <DelayRender test={test}>
              {SessionStore.userData && SessionStore.userData.skin !== 'embed' &&
                <Header store={store} {...this.props} />
              }

              {
                SessionStore.userData &&
                SessionStore.userData.skin === 'embed' &&
                this.props.routing.history.location.pathname.indexOf('/reports') > -1 &&
                <div className="toaster toaster--sm">
                  <div className="wrap">
                    <p>
                      All reports on this page are provided by SmarterProctoring. Please contact
                      <a
                        href="mailto:proctors@smarterproctoring.com?subject=Support%20Ticket"
                      >
                        SmarterProctoring support
                      </a> if you need additional information.
                    </p>
                  </div>
                </div>
              }

              {SessionStore.userData && SessionStore.userData.skin === 'embed' &&
                <Tools store={store} {...this.props} refresh={this.refresh} />
              }

              {React.cloneElement(this.props.children, this.props)}

              {SessionStore.userData && SessionStore.userData.skin !== 'embed' &&
                <Footer store={store} />
              }

              {store.SessionStore.expireWarning &&
                <ExpireWarning store={store} />
              }

              {store.SessionStore.dialog &&
                <Dialog store={store} {...this.props} />
              }

              {store.SessionStore.confirm &&
                <Confirm store={store} />
              }

              {store.SessionStore.prompt &&
                <Prompt store={store} />
              }

              {store.SessionStore.featureNotice &&
                <FeatureNotice store={store} {...this.props} />
              }

              {store.SessionStore.toaster &&
                <Toaster store={store} />
              }

              {store.SessionStore.notification &&
                <Notification store={store} {...this.props} />
              }

              {store.SessionStore.browserUnsupported &&
                <div className={`toaster toaster--warning toaster--sm`}>
                  <div className="wrap">
                    <p>You are using an unsupported browser. We recommend that you <a href="http://outdatedbrowser.com/" target="_blank">update your browser</a> for the best experience.</p>
                  </div>
                </div>
              }

              {store.SessionStore.loading &&
                <Loader store={store} />
              }

              <FeatureFlag
                flagKey='proctor-support-chat'
                renderFeatureCallback={this.embedSupportChat}
                renderDefaultCallback={() => null}
              />
            </DelayRender>
          </div>
        </LaunchDarkly>
      )
    }

    return null;
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/app/components/App.js